"use strict";
// This class implements docker commands using CLI, and
// it periodically monitors the docker daemon status.
// It manages containers defined in common.plugins.docker and could monitor other containers
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _DockerManagerOfOwnContainers_instances, _a, _DockerManagerOfOwnContainers_waitAllChecked, _DockerManagerOfOwnContainers_waitAllCheckedResolve, _DockerManagerOfOwnContainers_ownContainers, _DockerManagerOfOwnContainers_monitoringInterval, _DockerManagerOfOwnContainers_ownContainersStats, _DockerManagerOfOwnContainers_adapterDir, _DockerManagerOfOwnContainers_ensureActualConfiguration, _DockerManagerOfOwnContainers_modifyContainerName, _DockerManagerOfOwnContainers_checkOwnContainers, _DockerManagerOfOwnContainers_ownContainersMonitor;
Object.defineProperty(exports, "__esModule", { value: true });
const path_1 = require("path");
const DockerManager_1 = __importDefault(require("./DockerManager"));
const dockerDefaults = {
    tty: false,
    stdinOpen: false,
    attachStdin: false,
    attachStdout: false,
    attachStderr: false,
    openStdin: false,
    publishAllPorts: false,
    readOnly: false,
    user: '',
    workdir: '',
    domainname: '',
    macAddress: '',
    networkMode: 'bridge',
};
function isDefault(value, def) {
    return JSON.stringify(value) === JSON.stringify(def);
}
function deepCompare(object1, object2) {
    if (typeof object1 === 'number') {
        object1 = object1.toString();
    }
    if (typeof object2 === 'number') {
        object2 = object2.toString();
    }
    if (typeof object1 !== typeof object2) {
        return false;
    }
    if (typeof object1 !== 'object' || object1 === null || object2 === null) {
        return object1 === object2;
    }
    if (Array.isArray(object1)) {
        if (!Array.isArray(object2) || object1.length !== object2.length) {
            return false;
        }
        for (let i = 0; i < object1.length; i++) {
            if (!deepCompare(object1[i], object2[i])) {
                return false;
            }
        }
        return true;
    }
    const keys1 = Object.keys(object1);
    for (const key of keys1) {
        // ignore iob* properties as they belong to ioBroker configuration
        // ignore the hostname and dependsOn as it is only for docker-compose
        if (key.startsWith('iob') || key === 'hostname' || key === 'dependsOn' || key === 'devices') {
            continue;
        }
        if (!deepCompare(object1[key], object2[key])) {
            return false;
        }
    }
    return true;
}
function compareConfigs(_desired, _existing) {
    const diffs = [];
    const desired = JSON.parse(JSON.stringify(_desired));
    const existing = JSON.parse(JSON.stringify(_existing));
    const keys = Object.keys(desired);
    // Order mounts, volumes and ports to avoid diffs if only the order is different
    if (desired.mounts) {
        desired.mounts = desired.mounts.map(m => (Object.assign({}, m))).sort((a, b) => a.target.localeCompare(b.target));
        // readonly flag will be ignored, because it is not possible to change it without recreating the container, so it would always cause a diff
        desired.mounts.forEach(m => delete m.readOnly);
    }
    if (existing.mounts) {
        existing.mounts = existing.mounts.map(m => (Object.assign({}, m))).sort((a, b) => a.target.localeCompare(b.target));
        existing.mounts.forEach(m => delete m.readOnly);
        // "source": "iob_frigate_0_frigate_logs", => "source": "/var/lib/docker/volumes/iob_frigate_0_frigate_logs/_data",
        existing.mounts.forEach(m => {
            var _b;
            if (typeof m.source === 'string' && ((_b = m.source) === null || _b === void 0 ? void 0 : _b.includes('/volumes/')) && m.source.includes('/_data')) {
                const parts = m.source.split('/');
                m.source = parts[parts.length - 2];
            }
        });
    }
    if (desired.volumes) {
        desired.volumes = desired.volumes
            .map(v => v.trim())
            .filter(v => v)
            .sort();
    }
    if (existing.volumes) {
        existing.volumes = existing.volumes
            .map(v => v.trim())
            .filter(v => v)
            .sort();
    }
    if (desired.ports) {
        desired.ports = desired.ports
            .map(p => (Object.assign({}, p)))
            .sort((a, b) => {
            var _b;
            if (a.hostPort !== b.hostPort) {
                return parseInt(a.hostPort, 10) - parseInt(b.hostPort, 10);
            }
            if (a.hostIP !== b.hostIP && a.hostIP && b.hostIP) {
                return (_b = a.hostIP) === null || _b === void 0 ? void 0 : _b.localeCompare(b.hostIP);
            }
            return 0;
        });
    }
    if (existing.ports) {
        existing.ports = existing.ports
            .map(p => (Object.assign({}, p)))
            .sort((a, b) => {
            var _b;
            if (a.hostPort !== b.hostPort) {
                return parseInt(a.hostPort, 10) - parseInt(b.hostPort, 10);
            }
            if (a.hostIP !== b.hostIP && a.hostIP && b.hostIP) {
                return (_b = a.hostIP) === null || _b === void 0 ? void 0 : _b.localeCompare(b.hostIP);
            }
            return 0;
        });
    }
    // We only compare keys that are in the desired config
    for (const key of keys) {
        // ignore iob* properties as they belong to ioBroker configuration
        // ignore the hostname and dependsOn as it is only for docker-compose
        if (key.startsWith('iob') || key === 'hostname' || key === 'dependsOn' || key === 'devices') {
            continue;
        }
        if (typeof desired[key] === 'object' && desired[key] !== null) {
            if (Array.isArray(desired[key])) {
                if (!Array.isArray(existing[key]) || desired[key].length !== existing[key].length) {
                    diffs.push(key);
                }
                else {
                    for (let i = 0; i < desired[key].length; i++) {
                        if (!deepCompare(desired[key][i], existing[key][i])) {
                            diffs.push(`${key}[${i}]`);
                        }
                    }
                }
            }
            else {
                Object.keys(desired[key]).forEach((subKey) => {
                    if (!deepCompare(desired[key][subKey], existing[key][subKey])) {
                        diffs.push(`${key}.${subKey}`);
                    }
                });
            }
        }
        else if (desired[key] !== existing[key]) {
            diffs.push(key);
        }
    }
    return diffs;
}
// remove undefined entries recursively
function removeUndefined(obj) {
    if (Array.isArray(obj)) {
        const arr = obj.map(v => (v && typeof v === 'object' ? removeUndefined(v) : v)).filter(v => v !== undefined);
        if (!arr.length) {
            return undefined;
        }
        return arr;
    }
    if (obj && typeof obj === 'object') {
        const _obj = Object.fromEntries(Object.entries(obj)
            .map(([k, v]) => [k, v && typeof v === 'object' ? removeUndefined(v) : v])
            .filter(([_, v]) => v !== undefined &&
            v !== null &&
            v !== '' &&
            !(Array.isArray(v) && v.length === 0) &&
            !(typeof v === 'object' && Object.keys(v).length === 0)));
        if (Object.keys(_obj).length === 0) {
            return undefined;
        }
        return _obj;
    }
    if (obj === '') {
        return undefined;
    }
    return obj;
}
function cleanContainerConfig(obj, mayChange) {
    var _b;
    obj = removeUndefined(obj);
    Object.keys(obj).forEach(name => {
        var _b, _c, _d, _e;
        if (isDefault(obj[name], dockerDefaults[name])) {
            delete obj[name];
        }
        if (name === 'mounts') {
            if (!obj.mounts) {
                delete obj.mounts;
                return;
            }
            obj.mounts = obj.mounts.map((mount) => {
                const m = Object.assign({}, mount);
                // /var/lib/docker/volumes/influxdb_0_flux_config/_data
                if (mayChange && m.source.includes('/docker/volumes') && m.source.endsWith('/_data')) {
                    const parts = m.source.split('/');
                    m.source = parts[parts.length - 2];
                }
                delete m.readOnly;
                return m;
            });
            if (!obj.mounts.length) {
                delete obj.mounts;
                return;
            }
            (_b = obj.mounts) === null || _b === void 0 ? void 0 : _b.sort((a, b) => a.target.localeCompare(b.target));
        }
        if (name === 'ports') {
            if (!obj.ports) {
                delete obj.ports;
                return;
            }
            obj.ports = obj.ports.map((port) => {
                const p = Object.assign({}, port);
                if (p.protocol === 'tcp') {
                    delete p.protocol;
                }
                return p;
            });
            if (!obj.ports.length) {
                delete obj.ports;
                return;
            }
            (_c = obj.ports) === null || _c === void 0 ? void 0 : _c.sort((a, b) => {
                var _b;
                if (a.hostPort !== b.hostPort) {
                    return parseInt(a.hostPort, 10) - parseInt(b.hostPort, 10);
                }
                if (a.hostIP !== b.hostIP && a.hostIP && b.hostIP) {
                    return (_b = a.hostIP) === null || _b === void 0 ? void 0 : _b.localeCompare(b.hostIP);
                }
                return 0;
            });
        }
        if (name === 'environment') {
            if (!obj.environment) {
                delete obj.environment;
                return;
            }
            const env = obj.environment;
            if (Object.keys(env).length) {
                obj.environment = {};
                Object.keys(env)
                    .sort()
                    .forEach(key => {
                    if (key && env[key] && obj.environment) {
                        obj.environment[key] = env[key];
                    }
                });
            }
            else {
                delete obj.environment;
            }
            if (!Object.keys(env).length) {
                delete obj.environment;
            }
        }
        if (name === 'labels') {
            if (!obj.labels) {
                delete obj.labels;
                return;
            }
            const labels = obj.labels;
            if (Object.keys(labels).length) {
                obj.labels = {};
                Object.keys(labels)
                    .sort()
                    .forEach(key => {
                    if (key && labels[key] && obj.labels) {
                        obj.labels[key] = labels[key];
                    }
                });
            }
            else {
                delete obj.labels;
            }
            if (!Object.keys(labels).length) {
                delete obj.labels;
            }
        }
        if (name === 'volumes') {
            if (!((_d = obj.volumes) === null || _d === void 0 ? void 0 : _d.length)) {
                delete obj.volumes;
                return;
            }
            obj.volumes = obj.volumes.map(v => v.trim()).filter(v => v);
            obj.volumes.sort();
            if (!((_e = obj.volumes) === null || _e === void 0 ? void 0 : _e.length)) {
                delete obj.volumes;
            }
        }
        if (name === 'command') {
            if (!obj.command) {
                delete obj.command;
                return;
            }
            // Make from a command array with one string a string, because in this case both forms are possible
            if (Array.isArray(obj.command) && obj.command.length === 1 && typeof obj.command[0] === 'string') {
                obj.command = obj.command[0];
            }
        }
    });
    (_b = obj.volumes) === null || _b === void 0 ? void 0 : _b.sort();
    return obj;
}
class DockerManagerOfOwnContainers extends DockerManager_1.default {
    constructor(options, containers) {
        super(options);
        _DockerManagerOfOwnContainers_instances.add(this);
        _DockerManagerOfOwnContainers_waitAllChecked.set(this, void 0);
        _DockerManagerOfOwnContainers_waitAllCheckedResolve.set(this, void 0);
        _DockerManagerOfOwnContainers_ownContainers.set(this, []);
        _DockerManagerOfOwnContainers_monitoringInterval.set(this, null);
        _DockerManagerOfOwnContainers_ownContainersStats.set(this, {});
        _DockerManagerOfOwnContainers_adapterDir.set(this, void 0);
        this.forceRestart = options.forceRestart || false;
        __classPrivateFieldSet(this, _DockerManagerOfOwnContainers_adapterDir, options.adapterDir || '', "f");
        __classPrivateFieldSet(this, _DockerManagerOfOwnContainers_ownContainers, containers || [], "f");
        __classPrivateFieldSet(this, _DockerManagerOfOwnContainers_waitAllChecked, new Promise(resolve => (__classPrivateFieldSet(this, _DockerManagerOfOwnContainers_waitAllCheckedResolve, resolve, "f"))), "f");
    }
    /**
     * Convert information from `inspect` to docker configuration to start it
     *
     * @param inspect Inspect information
     */
    static mapInspectToConfig(inspect) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
        const obj = {
            image: inspect.Config.Image,
            name: inspect.Name.replace(/^\//, ''),
            command: (_b = inspect.Config.Cmd) !== null && _b !== void 0 ? _b : undefined,
            entrypoint: (_c = inspect.Config.Entrypoint) !== null && _c !== void 0 ? _c : undefined,
            user: (_d = inspect.Config.User) !== null && _d !== void 0 ? _d : undefined,
            workdir: (_e = inspect.Config.WorkingDir) !== null && _e !== void 0 ? _e : undefined,
            hostname: (_f = inspect.Config.Hostname) !== null && _f !== void 0 ? _f : undefined,
            domainname: (_g = inspect.Config.Domainname) !== null && _g !== void 0 ? _g : undefined,
            macAddress: (_h = inspect.NetworkSettings.MacAddress) !== null && _h !== void 0 ? _h : undefined,
            environment: inspect.Config.Env
                ? Object.fromEntries(inspect.Config.Env.map(e => {
                    const [key, ...rest] = e.split('=');
                    return [key, rest.join('=')];
                }))
                : undefined,
            labels: (_j = inspect.Config.Labels) !== null && _j !== void 0 ? _j : undefined,
            tty: inspect.Config.Tty,
            stdinOpen: inspect.Config.OpenStdin,
            attachStdin: inspect.Config.AttachStdin,
            attachStdout: inspect.Config.AttachStdout,
            attachStderr: inspect.Config.AttachStderr,
            openStdin: inspect.Config.OpenStdin,
            publishAllPorts: inspect.HostConfig.PublishAllPorts,
            ports: inspect.HostConfig.PortBindings
                ? Object.entries(inspect.HostConfig.PortBindings).flatMap(([containerPort, bindings]) => bindings.map(binding => ({
                    containerPort: containerPort.split('/')[0],
                    protocol: containerPort.split('/')[1] || 'tcp',
                    hostPort: binding.HostPort,
                    hostIP: binding.HostIp,
                })))
                : undefined,
            mounts: (_k = inspect.Mounts) === null || _k === void 0 ? void 0 : _k.map(mount => ({
                type: mount.Type,
                source: mount.Source,
                target: mount.Destination,
                readOnly: !mount.RW,
            })),
            volumes: inspect.Config.Volumes ? Object.keys(inspect.Config.Volumes) : inspect.HostConfig.Binds,
            extraHosts: (_l = inspect.HostConfig.ExtraHosts) !== null && _l !== void 0 ? _l : undefined,
            dns: {
                servers: inspect.HostConfig.Dns,
                search: inspect.HostConfig.DnsSearch,
                options: inspect.HostConfig.DnsOptions,
            },
            networkMode: inspect.HostConfig.NetworkMode,
            networks: inspect.NetworkSettings.Networks
                ? Object.entries(inspect.NetworkSettings.Networks).map(([name, net]) => {
                    var _b, _c;
                    return ({
                        name,
                        aliases: (_b = net.Aliases) !== null && _b !== void 0 ? _b : undefined,
                        ipv4Address: net.IPAddress,
                        ipv6Address: net.GlobalIPv6Address,
                        driverOpts: (_c = net.DriverOpts) !== null && _c !== void 0 ? _c : undefined,
                    });
                })
                : undefined,
            restart: {
                policy: inspect.HostConfig.RestartPolicy.Name,
                maxRetries: inspect.HostConfig.RestartPolicy.MaximumRetryCount,
            },
            resources: {
                cpuShares: inspect.HostConfig.CpuShares,
                cpuQuota: inspect.HostConfig.CpuQuota,
                cpuPeriod: inspect.HostConfig.CpuPeriod,
                cpusetCpus: inspect.HostConfig.CpusetCpus,
                memory: inspect.HostConfig.Memory,
                memorySwap: inspect.HostConfig.MemorySwap,
                memoryReservation: inspect.HostConfig.MemoryReservation,
                pidsLimit: (_m = inspect.HostConfig.PidsLimit) !== null && _m !== void 0 ? _m : undefined,
                shmSize: inspect.HostConfig.ShmSize,
                readOnlyRootFilesystem: inspect.HostConfig.ReadonlyRootfs,
            },
            logging: {
                driver: inspect.HostConfig.LogConfig.Type,
                options: inspect.HostConfig.LogConfig.Config,
            },
            security: {
                privileged: inspect.HostConfig.Privileged,
                capAdd: (_o = inspect.HostConfig.CapAdd) !== null && _o !== void 0 ? _o : undefined,
                capDrop: (_p = inspect.HostConfig.CapDrop) !== null && _p !== void 0 ? _p : undefined,
                usernsMode: (_q = inspect.HostConfig.UsernsMode) !== null && _q !== void 0 ? _q : undefined,
                ipc: inspect.HostConfig.IpcMode,
                pid: inspect.HostConfig.PidMode,
                seccomp: (_t = (_s = (_r = inspect.HostConfig.SecurityOpt) === null || _r === void 0 ? void 0 : _r.find(opt => opt.startsWith('seccomp='))) === null || _s === void 0 ? void 0 : _s.split('=')[1]) !== null && _t !== void 0 ? _t : undefined,
                apparmor: (_w = (_v = (_u = inspect.HostConfig.SecurityOpt) === null || _u === void 0 ? void 0 : _u.find(opt => opt.startsWith('apparmor='))) === null || _v === void 0 ? void 0 : _v.split('=')[1]) !== null && _w !== void 0 ? _w : undefined,
                groupAdd: (_x = inspect.HostConfig.GroupAdd) !== null && _x !== void 0 ? _x : undefined,
                noNewPrivileges: undefined, // Nicht direkt verfügbar
            },
            sysctls: (_y = inspect.HostConfig.Sysctls) !== null && _y !== void 0 ? _y : undefined,
            init: (_z = inspect.HostConfig.Init) !== null && _z !== void 0 ? _z : undefined,
            stop: {
                signal: (_0 = inspect.Config.StopSignal) !== null && _0 !== void 0 ? _0 : undefined,
                gracePeriodSec: (_1 = inspect.Config.StopTimeout) !== null && _1 !== void 0 ? _1 : undefined,
            },
            readOnly: inspect.HostConfig.ReadonlyRootfs,
            timezone: undefined, // Nicht direkt verfügbar
            __meta: undefined, // Eigene Metadaten
        };
        return cleanContainerConfig(obj, true);
    }
    async init() {
        var _b;
        await super.init();
        if (this.installed) {
            await __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_checkOwnContainers).call(this);
        }
        else {
            (_b = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_waitAllCheckedResolve, "f")) === null || _b === void 0 ? void 0 : _b.call(this);
        }
    }
    getDefaultContainerName() {
        return `iob_${this.namespace.replace(/[-.]/g, '_')}`;
    }
    /** Modify the configuration of own container by name */
    async ownContainerModify(containerName, changes) {
        containerName = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_modifyContainerName).call(this, containerName);
        const index = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f").findIndex(c => c.name === containerName);
        if (index === -1) {
            throw new Error(`Own container with name ${containerName} does not exist`);
        }
        const oldContainer = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f")[index];
        // todo may be use here deep merge?
        const newContainer = Object.assign(Object.assign({}, oldContainer), changes);
        if (changes.name && changes.name !== oldContainer.name) {
            newContainer.name = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_modifyContainerName).call(this, changes.name);
            if (__classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f").find(c => c.name === newContainer.name && c.name !== oldContainer.name)) {
                throw new Error(`Own container with name "${newContainer.name}" already exists`);
            }
        }
        __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f")[index] = cleanContainerConfig(newContainer);
        // start monitoring if necessary
        if (newContainer.iobMonitoringEnabled && !__classPrivateFieldGet(this, _DockerManagerOfOwnContainers_monitoringInterval, "f")) {
            __classPrivateFieldSet(this, _DockerManagerOfOwnContainers_monitoringInterval, setInterval(() => __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_ownContainersMonitor).call(this), 60000), "f");
        }
        // check the container
        await __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_checkOwnContainers).call(this);
    }
    /** Add new own container */
    async ownContainerAdd(container) {
        container.name = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_modifyContainerName).call(this, container.name);
        if (container.iobEnabled === false) {
            // do not add disabled containers
            return;
        }
        if (__classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f").find(c => c.name === container.name)) {
            throw new Error(`Own container with name "${container.name}" already exists`);
        }
        __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f").push(container);
        // start monitoring if necessary
        if (container.iobMonitoringEnabled && !__classPrivateFieldGet(this, _DockerManagerOfOwnContainers_monitoringInterval, "f")) {
            __classPrivateFieldSet(this, _DockerManagerOfOwnContainers_monitoringInterval, setInterval(() => __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_ownContainersMonitor).call(this), 60000), "f");
        }
        // check the container
        await __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_checkOwnContainers).call(this);
    }
    /** Remove own container by name */
    async ownContainerRemove(containerName) {
        containerName = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_modifyContainerName).call(this, containerName);
        const index = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f").findIndex(c => c.name === containerName);
        if (index === -1) {
            throw new Error(`Own container with name ${containerName} does not exist`);
        }
        __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f").splice(index, 1);
        delete __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainersStats, "f")[containerName];
        // if no own containers with monitoring enabled, stop monitoring
        if (!__classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f").find(c => c.iobMonitoringEnabled) && __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_monitoringInterval, "f")) {
            clearInterval(__classPrivateFieldGet(this, _DockerManagerOfOwnContainers_monitoringInterval, "f"));
            __classPrivateFieldSet(this, _DockerManagerOfOwnContainers_monitoringInterval, null, "f");
        }
        await this.containerRemove(containerName);
        // Try to remove network and volumes
        const prefix = this.getDefaultContainerName();
        try {
            const networks = await this.networkList();
            for (const n of networks) {
                if (n.name.startsWith(`${prefix}_`) || n.name === prefix) {
                    await this.networkRemove(n.name);
                }
            }
        }
        catch (_b) {
            // ignore, as maybe it used by someone else
        }
        try {
            const volumes = await this.volumeList();
            for (const v of volumes) {
                if (v.name.startsWith(`${prefix}_`) || v.name === prefix) {
                    await this.volumeRemove(v.name);
                }
            }
        }
        catch (_c) {
            // ignore, as maybe it used by someone else
        }
    }
    /** Wait till all own containers are checked */
    ownContainerCheckedAll() {
        return __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_waitAllChecked, "f");
    }
    /** Read own container stats */
    getOwnContainerStats() {
        return __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainersStats, "f");
    }
    /** Stop own containers if necessary */
    async destroy() {
        await super.destroy();
        if (__classPrivateFieldGet(this, _DockerManagerOfOwnContainers_monitoringInterval, "f")) {
            clearInterval(__classPrivateFieldGet(this, _DockerManagerOfOwnContainers_monitoringInterval, "f"));
            __classPrivateFieldSet(this, _DockerManagerOfOwnContainers_monitoringInterval, null, "f");
        }
        for (const container of __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f")) {
            if (container.iobEnabled !== false && container.iobStopOnUnload && container.name) {
                this.log.info(`Stopping own container ${container.name} on destroy`);
                try {
                    await this.containerStop(container.name);
                }
                catch (e) {
                    this.log.warn(`Cannot stop own container ${container.name} on destroy: ${e.message}`);
                }
            }
        }
    }
}
_a = DockerManagerOfOwnContainers, _DockerManagerOfOwnContainers_waitAllChecked = new WeakMap(), _DockerManagerOfOwnContainers_waitAllCheckedResolve = new WeakMap(), _DockerManagerOfOwnContainers_ownContainers = new WeakMap(), _DockerManagerOfOwnContainers_monitoringInterval = new WeakMap(), _DockerManagerOfOwnContainers_ownContainersStats = new WeakMap(), _DockerManagerOfOwnContainers_adapterDir = new WeakMap(), _DockerManagerOfOwnContainers_instances = new WeakSet(), _DockerManagerOfOwnContainers_ensureActualConfiguration = 
/**
 * Ensure that the given container is running with the actual configuration
 *
 * @param container Container configuration
 */
async function _DockerManagerOfOwnContainers_ensureActualConfiguration(container) {
    if (!container.name) {
        throw new Error(`Container name must be a string, but got boolean true`);
    }
    // Check the configuration of the container
    const inspect = await this.containerInspect(container.name);
    if (inspect) {
        const existingConfig = _a.mapInspectToConfig(inspect);
        console.log(`Compare existing config and desired config for ${container.name}`);
        container = cleanContainerConfig(container);
        const diffs = compareConfigs(container, existingConfig);
        if (diffs.length) {
            this.log.info(`Configuration of own container ${container.name} has changed: ${diffs.join(', ')}. Restarting container...`);
            const result = await this.containerReCreate(container);
            if (result.stderr) {
                this.log.warn(`Cannot recreate own container ${container.name}: ${result.stderr}`);
            }
        }
        else {
            this.log.debug(`Configuration of own container ${container.name} is up to date`);
        }
        // Check if the container is running
        const status = await this.containerList(true);
        const containerInfo = status.find(it => it.names === container.name);
        if (containerInfo) {
            if (containerInfo.status !== 'running' && containerInfo.status !== 'restarting') {
                // Start the container
                this.log.info(`Starting own container ${container.name}`);
                try {
                    const result = await this.containerStart(containerInfo.id);
                    if (result.stderr) {
                        this.log.warn(`Cannot start own container ${container.name}: ${result.stderr}`);
                    }
                }
                catch (e) {
                    this.log.warn(`Cannot start own container ${container.name}: ${e.message}`);
                }
            }
            else {
                if (this.forceRestart) {
                    this.log.info(`Force restarting own container ${container.name}`);
                    try {
                        await this.containerRestart(containerInfo.id);
                    }
                    catch (e) {
                        this.log.warn(`Cannot restart own container ${container.name}: ${e.message}`);
                    }
                }
                else {
                    this.log.debug(`Own container ${container.name} is already running`);
                }
            }
        }
        else {
            this.log.warn(`Own container ${container.name} not found in container list after recreation`);
        }
    }
}, _DockerManagerOfOwnContainers_modifyContainerName = function _DockerManagerOfOwnContainers_modifyContainerName(containerName) {
    const prefix = this.getDefaultContainerName();
    if (containerName === true || containerName === 'true' || !containerName) {
        return prefix;
    }
    if (typeof containerName === 'string') {
        // The name of the container, name of the network and name of the volume must start with iob_<Adaptername>_<instance>_
        if (containerName !== prefix && !containerName.startsWith(`${prefix}_`)) {
            this.log.debug(`Renaming container ${containerName} to be prefixed with iob_${prefix}_`);
            return `${prefix}_${containerName}`;
        }
        return containerName;
    }
    throw new Error(`Container name must be a string, but got boolean ${containerName}`);
}, _DockerManagerOfOwnContainers_checkOwnContainers = async function _DockerManagerOfOwnContainers_checkOwnContainers() {
    var _b, _c, _d, _e;
    if (!__classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f").length) {
        (_b = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_waitAllCheckedResolve, "f")) === null || _b === void 0 ? void 0 : _b.call(this);
        return;
    }
    const status = await this.containerList(true);
    let images = await this.imageList();
    let anyStartedOrRunning = false;
    const networkChecked = [];
    const prefix = this.getDefaultContainerName();
    for (let c = 0; c < __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f").length; c++) {
        const container = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f")[c];
        if (container.iobEnabled !== false) {
            if (!container.image.includes(':')) {
                container.image += ':latest';
            }
            if (((_c = container.labels) === null || _c === void 0 ? void 0 : _c.iobroker) !== this.namespace) {
                container.labels = Object.assign(Object.assign({}, container.labels), { iobroker: this.namespace });
            }
            container.name = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_modifyContainerName).call(this, container.name);
            try {
                // create iobroker network if necessary
                if (container.networkMode &&
                    container.networkMode !== 'container' &&
                    container.networkMode !== 'host' &&
                    container.networkMode !== 'bridge' &&
                    container.networkMode !== 'none') {
                    if (container.networkMode === true || container.networkMode === 'true') {
                        container.networkMode = prefix;
                    }
                    if (container.networkMode !== 'iobroker' &&
                        container.networkMode !== prefix &&
                        !container.networkMode.startsWith(`${prefix}_`)) {
                        this.log.debug(`Renaming network ${container.networkMode} to be prefixed with ${prefix}_`);
                        container.networkMode = `${prefix}_${container.networkMode}`;
                    }
                    if (!networkChecked.includes(container.networkMode)) {
                        // check if the network exists
                        const networks = await this.networkList();
                        if (!networks.find(it => it.name === container.networkMode)) {
                            this.log.info(`Creating docker network ${container.networkMode}`);
                            await this.networkCreate(container.networkMode);
                        }
                        networkChecked.push(container.networkMode);
                    }
                }
                // create all volumes ourselves, to have a static name
                if ((_d = container.mounts) === null || _d === void 0 ? void 0 : _d.find(m => m.type === 'volume')) {
                    // check if the volume exists
                    const volumes = await this.volumeList();
                    for (const mount of container.mounts) {
                        if (mount.type === 'volume' && mount.source) {
                            if (mount.source === true || mount.source === 'true') {
                                mount.source = prefix;
                            }
                            if (mount.source !== prefix && !mount.source.startsWith(`${prefix}_`)) {
                                this.log.debug(`Renaming volume ${mount.source} to be prefixed with ${prefix}_`);
                                mount.source = `${prefix}_${mount.source}`;
                            }
                            if (mount.iobBackup) {
                                if (!container.labels.iob_backup) {
                                    container.labels = Object.assign(Object.assign({}, container.labels), { iob_backup: mount.source });
                                }
                                else {
                                    const volumes = container.labels.iob_backup
                                        .split(',')
                                        .map(v => v.trim())
                                        .filter(v => v);
                                    if (!volumes.includes(mount.source)) {
                                        volumes.push(mount.source);
                                        container.labels = Object.assign(Object.assign({}, container.labels), { iob_backup: volumes.join(',') });
                                    }
                                }
                            }
                            if (mount.iobAutoCopyFrom &&
                                (!mount.iobAutoCopyFrom.startsWith('/') ||
                                    mount.iobAutoCopyFrom.match(/^[a-zA-Z]:/))) {
                                mount.iobAutoCopyFrom = (0, path_1.join)(__classPrivateFieldGet(this, _DockerManagerOfOwnContainers_adapterDir, "f"), mount.iobAutoCopyFrom);
                            }
                            const volume = volumes.find(v => v.name === mount.source);
                            if (!volume) {
                                this.log.info(`Creating docker volume ${mount.source}`);
                                const result = await this.volumeCreate(mount.source);
                                if (result.stderr) {
                                    this.log.warn(`Cannot create volume ${mount.source}: ${result.stderr}`);
                                    continue;
                                }
                                // Copy data from host to volume
                                if (mount.iobAutoCopyFrom) {
                                    await this.volumeCopyTo(mount.source, mount.iobAutoCopyFrom);
                                }
                            }
                            else if (mount.iobAutoCopyFromForce && mount.iobAutoCopyFrom) {
                                // Copy data from host to volume
                                await this.volumeCopyTo(mount.source, mount.iobAutoCopyFrom);
                            }
                        }
                    }
                }
                let containerInfo = status.find(it => it.names === container.name);
                let image = images.find(it => `${it.repository}:${it.tag}` === container.image);
                if (container.iobAutoImageUpdate) {
                    // ensure that the image is actual
                    const newImage = await this.imageUpdate(container.image, true);
                    if (newImage) {
                        this.log.info(`Image ${container.image} for own container ${container.name} was updated`);
                        if (containerInfo) {
                            // destroy current container
                            await this.containerRemove(containerInfo.id);
                            containerInfo = undefined;
                        }
                        image = newImage;
                    }
                }
                if (!image) {
                    this.log.info(`Pulling image ${container.image} for own container ${container.name}. This may take some time...`);
                    try {
                        const result = await this.imagePull(container.image);
                        if (result.stderr) {
                            this.log.warn(`Cannot pull image ${container.image}: ${result.stderr}`);
                            continue;
                        }
                    }
                    catch (e) {
                        this.log.warn(`Cannot pull image ${container.image}: ${e.message}`);
                        continue;
                    }
                    // Check that the image is available now
                    images = await this.imageList();
                    image = images.find(it => `${it.repository}:${it.tag}` === container.image);
                    if (!image) {
                        this.log.warn(`Image ${container.image} for own container ${container.name} not found after pull`);
                        continue;
                    }
                }
                if (containerInfo) {
                    await __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_ensureActualConfiguration).call(this, container);
                    anyStartedOrRunning || (anyStartedOrRunning = !!container.iobMonitoringEnabled);
                }
                else {
                    // Create and start the container, as the container was not found
                    this.log.info(`Creating and starting own container ${container.name}`);
                    try {
                        const result = await this.containerRun(container);
                        if (result.stderr) {
                            this.log.warn(`Cannot start own container ${container.name}: ${result.stderr}`);
                        }
                        else {
                            anyStartedOrRunning || (anyStartedOrRunning = !!container.iobMonitoringEnabled);
                        }
                    }
                    catch (e) {
                        this.log.warn(`Cannot start own container ${container.name}: ${e.message}`);
                    }
                }
            }
            catch (e) {
                this.log.warn(`Cannot check own container ${container.name}: ${e.message}`);
            }
        }
    }
    if (anyStartedOrRunning) {
        __classPrivateFieldSet(this, _DockerManagerOfOwnContainers_monitoringInterval, __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_monitoringInterval, "f") || setInterval(() => __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_instances, "m", _DockerManagerOfOwnContainers_ownContainersMonitor).call(this), 60000), "f");
    }
    (_e = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_waitAllCheckedResolve, "f")) === null || _e === void 0 ? void 0 : _e.call(this);
}, _DockerManagerOfOwnContainers_ownContainersMonitor = async function _DockerManagerOfOwnContainers_ownContainersMonitor() {
    // get the status of containers
    const containers = await this.containerList();
    // Check the status of own containers
    for (let c = 0; c < __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f").length; c++) {
        const container = __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainers, "f")[c];
        if (container.iobEnabled !== false && container.iobMonitoringEnabled && container.name) {
            // Check if the container is running
            const running = containers.find(it => it.names === container.name);
            if (!running || (running.status !== 'running' && running.status !== 'restarting')) {
                this.log.warn(`Own container ${container.name} is not running. Restarting...`);
                try {
                    const result = await this.containerStart(container.name);
                    if (result.stderr) {
                        this.log.warn(`Cannot start own container ${container.name}: ${result.stderr}`);
                        __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainersStats, "f")[container.name] = Object.assign(Object.assign({}, __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainersStats, "f")[container.name]), { status: (running === null || running === void 0 ? void 0 : running.status) || 'unknown', statusTs: Date.now() });
                        continue;
                    }
                }
                catch (e) {
                    this.log.warn(`Cannot start own container ${container.name}: ${e.message}`);
                    __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainersStats, "f")[container.name] = Object.assign(Object.assign({}, __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainersStats, "f")[container.name]), { status: (running === null || running === void 0 ? void 0 : running.status) || 'unknown', statusTs: Date.now() });
                    continue;
                }
            }
            // check the stats
            __classPrivateFieldGet(this, _DockerManagerOfOwnContainers_ownContainersStats, "f")[container.name] = Object.assign(Object.assign({}, ((await this.containerGetRamAndCpuUsage(container.name)) || {})), { status: (running === null || running === void 0 ? void 0 : running.status) || 'unknown', statusTs: Date.now() });
        }
    }
};
exports.default = DockerManagerOfOwnContainers;
